/**
 * Lightweight variadic logger — drop-in replacement for `console.*`.
 *
 * - In development: forwards to the real console.
 * - In production: silences debug/info/log, keeps warn/error.
 *
 * Use this for ad-hoc logging. For structured logging with context
 * (component, action, sessionId), use `logger` from './logger'.
 */

const isDev = import.meta.env.MODE !== "production";

type LogFn = (...args: unknown[]) => void;

const noop: LogFn = () => {};

export const log: {
  log: LogFn;
  info: LogFn;
  debug: LogFn;
  warn: LogFn;
  error: LogFn;
} = {
  log: isDev ? (...a) => console.log(...a) : noop,
  info: isDev ? (...a) => console.info(...a) : noop,
  debug: isDev ? (...a) => console.debug(...a) : noop,
  // Always surface warnings and errors so issues are visible in prod consoles
  // and forwarded to error-tracking middleware (e.g. Sentry, LogRocket).
  warn: (...a) => console.warn(...a),
  error: (...a) => console.error(...a),
};
